import { jsx as e, jsxs as n, Fragment as O } from "react/jsx-runtime";
import { forwardRef as N, useState as I, useRef as T, useEffect as A, useCallback as p, useImperativeHandle as _ } from "react";
import o from "./styles.module.less.js";
import B from "./logo.svg.js";
import D from "./close-icon.svg.js";
import { Modal as E } from "../../general/modal/index.js";
import { MOBILE_WIDTH as R, TABLET_WIDTH as $ } from "../../../utils/use-is-mobile.js";
import { CheckboxInput as H } from "../../general/checkbox-label/index.js";
const M = "terms-accepted", x = N((t, h) => {
  const {
    description: C,
    image: u,
    mobileImage: s,
    tabletImage: c,
    termsTitle: d,
    actionButton: r,
    bannerText: a,
    price: m,
    defaultOpen: k,
    closeIcon: b
  } = t, [l, i] = I(!1), w = T(null), [f, y] = I(!1);
  A(() => {
    l ? document.body.style.overflow = "hidden" : l === !1 && (document.body.style.overflow = "auto");
  }, [l]);
  const S = p(() => i(!0), []), W = p(() => i(!1), []), L = p(() => {
    f ? (localStorage.removeItem(M), y(!1)) : (localStorage.setItem(M, "true"), y(!0));
  }, [f]), v = /* @__PURE__ */ e(
    "button",
    {
      className: o.infoBodyContentActionButton,
      disabled: !f,
      onClick: r == null ? void 0 : r.onClick,
      children: r == null ? void 0 : r.text
    }
  );
  return /* @__PURE__ */ e(
    E,
    {
      ref: h,
      className: o.infoModal,
      defaultOpen: k ?? !1,
      isSimple: !0,
      onOpen: S,
      onClose: W,
      closeIcon: b,
      children: /* @__PURE__ */ n("div", { className: o.infoModalContent, ref: w, children: [
        /* @__PURE__ */ n("div", { className: o.headerCard, children: [
          /* @__PURE__ */ n("picture", { className: o.headerCardImageWrapper, children: [
            s && /* @__PURE__ */ e(
              "source",
              {
                srcSet: s,
                media: `(max-width: ${R}px)`
              }
            ),
            c && /* @__PURE__ */ e(
              "source",
              {
                srcSet: c,
                media: `(max-width: ${$}px)`
              }
            ),
            " ",
            /* @__PURE__ */ e(
              "img",
              {
                src: u,
                alt: "info-header-card",
                className: o.headerCardImage
              }
            )
          ] }),
          /* @__PURE__ */ e(B, { className: o.headerCardLogo }),
          a && /* @__PURE__ */ n("div", { className: o.bannerText, children: [
            a,
            m && /* @__PURE__ */ e("div", { className: o.price, children: m })
          ] })
        ] }),
        /* @__PURE__ */ e("div", { className: o.infoBodyContainer, children: /* @__PURE__ */ n("div", { className: o.infoBodyContent, children: [
          /* @__PURE__ */ e("div", { className: o.infoBodyContentDescription, children: C }),
          /* @__PURE__ */ n("div", { className: o.infoBodyContentTerms, children: [
            d && /* @__PURE__ */ e("div", { className: o.infoBodyContentTermsTitle, children: d }),
            /* @__PURE__ */ e("div", { className: o.termsClickable, children: /* @__PURE__ */ e(
              H,
              {
                label: /* @__PURE__ */ n("div", { className: o.termsClickableText, children: [
                  "I have read, understood, and agreed to our ",
                  /* @__PURE__ */ e(
                    "a",
                    {
                      href: "/en-us/terms",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      onClick: (g) => g.stopPropagation(),
                      children: "terms"
                    }
                  ),
                  " and ",
                  /* @__PURE__ */ e(
                    "a",
                    {
                      href: "/en-us/privacy",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      onClick: (g) => g.stopPropagation(),
                      children: "privacy policy"
                    }
                  ),
                  "."
                ] }),
                onChange: L,
                checked: f,
                className: o.termsCheckbox
              }
            ) })
          ] }),
          /* @__PURE__ */ e("div", { className: o.infoBodyContentAction, children: r != null && r.link ? /* @__PURE__ */ e("a", { href: r == null ? void 0 : r.link, children: v }) : v })
        ] }) })
      ] })
    }
  );
});
x.displayName = "InfoModal";
const P = N((t, h) => {
  const {
    actionButtonText: C,
    price: u,
    learnMoreLink: s,
    startMyWillLink: c,
    onStartMyWillClick: d,
    closeOnLinkClick: r
  } = t, a = T(null), m = t.bannerText ?? "From";
  _(h, () => ({
    openModal: () => {
      var l;
      return (l = a.current) == null ? void 0 : l.openModal();
    },
    closeModal: () => {
      var l;
      return (l = a.current) == null ? void 0 : l.closeModal();
    }
  }));
  const k = p((l) => {
    var i;
    r && (l.preventDefault(), (i = a.current) == null || i.closeModal());
  }, [r]);
  let b = t.description ?? /* @__PURE__ */ n(O, { children: [
    "Get peace of mind with our online will creation service ",
    /* @__PURE__ */ e("span", { style: { fontWeight: "700" }, children: "$199" }),
    " for singles, or ",
    /* @__PURE__ */ e("span", { style: { fontWeight: "700" }, children: "$299" }),
    " or a mirror will for your spouse.",
    /* @__PURE__ */ e("br", {}),
    "An easy, step-by-step process that won't take long. ",
    /* @__PURE__ */ e("br", {}),
    /* @__PURE__ */ e("a", { href: s, target: "_blank", rel: "noopener noreferrer", onClick: k, children: "Learn more." }),
    /* @__PURE__ */ e("br", {})
  ] });
  return /* @__PURE__ */ e(
    x,
    {
      ref: a,
      image: "/wills/will-info-header-desktop.webp",
      mobileImage: "/wills/will-info-header-mobile.webp",
      description: b,
      bannerText: m,
      price: u,
      termsTitle: "Will creation privacy and terms",
      actionButton: {
        text: C ?? "Start my will",
        link: c,
        onClick: d
      },
      closeIcon: /* @__PURE__ */ e(D, {})
    }
  );
});
P.displayName = "WillInfoModal";
export {
  x as InfoModal,
  M as TERMS_ACCEPTED_ID,
  P as WillInfoModal
};
